import { memo } from "react";
import { Chip } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { useAvailableTeleconsultoria } from "../../hooks/useAvailableTeleconsultoria";
import { useTeleconsultoriaPresence } from "../../presence/useTeleconsultoriaPresence";

/**
 * Atalho "N online agora": abre a marcação (lá fica o "Atender agora").
 * Checa presença SÓ de quem está com a disponibilidade ligada (sem buscar
 * horários). Ninguém online: o chip não aparece.
 */
export const OnlineTeleconsultoresChip = memo(function OnlineTeleconsultoresChip({
  onClick,
}: {
  onClick: () => void;
}) {
  const { rows } = useAvailableTeleconsultoria();
  const presence = useTeleconsultoriaPresence([
    ...new Set(rows.map((row) => row.guest.practitioner.reference)),
  ]);
  const onlineCount = Object.values(presence).filter((status) => status === "online").length;

  if (!onlineCount) return null;
  return (
    <Chip
      clickable
      color="success"
      variant="outlined"
      icon={<FiberManualRecord sx={{ fontSize: 12 }} />}
      label={`${onlineCount} teleconsultor${onlineCount === 1 ? "" : "es"} online agora`}
      onClick={onClick}
      sx={{ alignSelf: "flex-start" }}
    />
  );
});
